module.exports = __webpack_public_path__ + "assets/img/banner.65868a27.jpg";